import { PORTAL_PERMISSIONS } from '@constants/portal-permissions.constant';
import { REGISTRATIONS_PERMISSIONS } from '@constants/registrations-permissions.constant';
import { EUserProfileIds, type IUser } from '@interfaces/user';

function isSellerOrAdmin(user?: IUser | null): boolean {
	return (
		user?.profileId === EUserProfileIds.SELLER ||
		user?.profileId === EUserProfileIds.APPLICATION_ADMIN
	);
}

function isApplicationAdmin(user?: IUser | null): boolean {
	return user?.profileId === EUserProfileIds.APPLICATION_ADMIN;
}

function hasPermission(user: IUser | null | undefined, permission: string) {
	return user?.profilePermissions?.includes(permission) ?? false;
}

/**
 * Tenant must have portalOrders.
 * APPLICATION_ADMIN always allowed (Kai); SELLER needs portal.createOrders.
 */
export function canCreatePortalOrders(
	user: IUser | null | undefined,
	options: {
		portalOrdersEnabled: boolean;
	}
): boolean {
	if (!user || !options.portalOrdersEnabled || !isSellerOrAdmin(user)) {
		return false;
	}
	if (isApplicationAdmin(user)) return true;
	return hasPermission(user, PORTAL_PERMISSIONS.createOrders);
}

/**
 * Same base roles + portalOrders.
 * APPLICATION_ADMIN always allowed; SELLER needs registrations.manageClients.
 */
export function canManagePortalClients(
	user: IUser | null | undefined,
	options: {
		portalOrdersEnabled: boolean;
	}
): boolean {
	if (!user || !options.portalOrdersEnabled || !isSellerOrAdmin(user)) {
		return false;
	}
	if (isApplicationAdmin(user)) return true;
	return hasPermission(user, REGISTRATIONS_PERMISSIONS.manageClients);
}
